module.exports = __webpack_public_path__ + "img/index_bottom.00f92252.png";